import React, { Fragment } from "react";
import { Seo, Breadcrumb, ScrollTopBtn } from "../components";
import {
  HeaderThree,
  ServiceFour,
  AboutOne,
  // TeamTwo,
  FaqTwo,
  AboutTwo,
  TestimonialThree,
  AboutFive,
  AboutSix,
  PricePlanOne,
  CtaOne,
  // BlogFour,
  BrandTwo,
  FooterTwo,
} from "../containers";

const Training = () => (
  <Fragment>
    <Seo
      title="Training"
      description="Learn more about Tech Ayukta, a leading IT Solutions company providing Web Development, App Development, ERP, and IT Consulting."
      keywords="Tech Ayukta, IT Solutions, About Tech Ayukta, Software Company"
      canonical="https://www.techayukta.com/about"
    />

    <HeaderThree />
    <Breadcrumb
      pageName="Training"
      bgImage="/images/breadcumb/breadcumb-bg.jpg"
    />
    {/* <ServiceFour className="space-top space-extra-bottom" /> */}
    <AboutOne className="mt-5"/>
    <AboutTwo className="space-top space-extra-bottom"/>
    {/* <TeamTwo className="space-top space-extra-bottom"/> */}
    <AboutSix className="space"/>
    <AboutFive className="space-top space-extra-bottom"/>
    {/* <TestimonialThree className="space-top space-extra-bottom" /> */}
      <PricePlanOne className=" space-extra"/>
    <FaqTwo className="mt-5"/>
    <CtaOne className="space" />
    <BrandTwo className="space" />
    {/* <BlogFour className="space-top space-extra-bottom"/> */}
    <FooterTwo />
    <ScrollTopBtn />
  </Fragment>
);

export default Training;
